import React from 'react';

// Custom Edge Component for React Flow
const CustomEdge = ({ id, sourceX, sourceY, targetX, targetY, style, label, labelStyle, markerEnd, animated }) => {
  // Define variables for source and target numbers
  const matches = id.match(/structNode-(\d+)-structNode-(\d+)/);
  const baseOffset = 40;
  const transitionOffset = style?.offsetReverseTransition || 0;
  const labelPosition = { x: 0, y: (sourceY + targetY) / 2 };
  const isLeftSide = style?.side === 'left';
  const strokeColor = style?.stroke || '#bbb';

  let path = '';
  let horizontalOffset = 0;
  let isRightToRight = false;

  if (matches) {
    // Extract source and target numbers
    const sourceNum = parseInt(matches[1], 10);
    const targetNum = parseInt(matches[2], 10);

    // Calculate the difference between source and target to adjust the path
    const diff = Math.abs(sourceNum - targetNum);
    isRightToRight = !isLeftSide && diff <= 2;
    const offsetDueToSize = isRightToRight
      ? (sourceX < targetX ? targetX - sourceX : 0)
      : (sourceX > targetX ? sourceX - targetX : 0);

    horizontalOffset = baseOffset + transitionOffset + offsetDueToSize;

    if (isLeftSide) {
      path = `M ${sourceX},${sourceY}
              L ${sourceX - horizontalOffset},${sourceY - 15}
              L ${sourceX - horizontalOffset},${targetY + 15}
              L ${targetX},${targetY}`;
    } else {
      path = `M ${sourceX},${sourceY}
              L ${sourceX + horizontalOffset},${sourceY - 15}
              L ${sourceX + horizontalOffset},${targetY + 15}
              L ${targetX},${targetY}`;
    }

    labelPosition.x = isLeftSide ? sourceX - horizontalOffset : sourceX + horizontalOffset;
  } else {
    if (style?.verticallOffset) {
  
      const leftOffset = Math.min(sourceX, targetX) - style?.verticallOffset ;
      path = `M ${sourceX},${sourceY-50}
              L ${leftOffset},${sourceY-50}
              L ${leftOffset},${targetY-50}
              L ${targetX-150},${targetY-50}`;
  
      labelPosition.x = leftOffset;
  
    } else if (strokeColor === 'red') {
      horizontalOffset = 25 + Math.max(sourceX, targetX);
      path = `M ${sourceX},${sourceY}
              L ${horizontalOffset},${sourceY}
              L ${horizontalOffset},${targetY}
              L ${targetX},${targetY}`;
      labelPosition.x = 25 + horizontalOffset;
  
    } else {
      path = `M ${sourceX},${sourceY} L ${targetX},${targetY}`;
      labelPosition.x = (sourceX + targetX) / 2;
    }
  }

  // Label Y-position remains constant in both cases
  const labelY = labelPosition.y;
  const isRedAndAnimated = animated && strokeColor === 'red';
  const isOverlapped = animated && style?.verticallOffset
  return (
    <g>
      <defs>
        <marker
          id="arrowhead"
          markerWidth="15"
          markerHeight="10"
          refX="15"
          refY="5"
          orient="auto"
          markerUnits="userSpaceOnUse"
        >
          <polygon points="0 0, 15 5, 0 10" fill="#f00" />
        </marker>
      </defs>
      <path
        id={id}
        style={{
          ...style,
          strokeWidth:isRedAndAnimated ? 2: 0.75,
          strokeDasharray: isRedAndAnimated || isOverlapped ? '5, 5' : 'none',
        }}
        d={path}
        markerEnd={markerEnd || "url(#arrowhead)"} // Default marker if none is provided
        fill="none"
      />
      {label && (
        <text x={labelPosition.x + 10} y={labelY} style={labelStyle}>
          {label}
        </text>
      )}
    </g>
  );
};

export default CustomEdge;
